import React, { useEffect, useState } from 'react'
import { Tabs } from 'components'
import TabPanel from 'components/TabPanel'
import { addKeyToObjectsArray } from 'utils/addUniqueKeyToObjects'
import { useSelector } from 'react-redux'
import jwtDecode from 'jwt-decode'

import { ROUTE_CONSTANTS } from 'utils/constants/routeConstants'
import { history } from 'redux/store'
import Cnaes from 'components/OptionsConfig/Cnaes'
import CompaniesKeywords from 'components/OptionsConfig/CompaniesKeywords'
import ProcessKeywords from 'components/OptionsConfig/ProcessKeywords'
import ComplianceList from 'components/OptionsConfig/ComplianceList'

import styles from './styles'

const ConfigOptions = () => {
  const classes = styles()
  const token = useSelector((state) => state.auth.access_token)

  const [activeTab, setActiveTab] = useState(0)

  const tabs = addKeyToObjectsArray([
    { label: 'Lista de CNAES' },
    { label: 'Palavras-chave de Empresas' },
    { label: 'Palavras-chave de processos' },
    { label: 'Compliance List' },
  ])

  useEffect(() => {
    const decoded = jwtDecode(token)
    if (!decoded.extras.scopes.includes('ADMIN')) {
      history.push(ROUTE_CONSTANTS.HOME)
      history.go()
    }
  }, [token])

  return (
    <div className={classes.root}>
      <div className={classes.textContent}>
        <h2>Configurações de restrições e buscas</h2>
        <p>
          Nesta tela é possível visualizar, buscar e adicionar restrições e
          opções de busca das categorias exibidas abaixo. Para mudar de
          categoria basta clicar no nome da mesma.
        </p>
      </div>
      <div className={classes.tabWrapper}>
        <Tabs
          initialValue={0}
          tabs={tabs}
          onChange={(value) => setActiveTab(value)}
        ></Tabs>
        <TabPanel value={activeTab} index={0} className={classes.panel}>
          <Cnaes />
        </TabPanel>
        <TabPanel value={activeTab} index={1} className={classes.panel}>
          <CompaniesKeywords />
        </TabPanel>
        <TabPanel value={activeTab} index={2} className={classes.panel}>
          <ProcessKeywords />
        </TabPanel>
        <TabPanel value={activeTab} index={3} className={classes.panel}>
          <ComplianceList />
        </TabPanel>
      </div>
    </div>
  )
}

ConfigOptions.propTypes = {}

export default ConfigOptions
